import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { IndexedDBLanguageDetector } from '@/lib/i18n-backend'
import { storage } from '@/lib/storage'

import itTranslations from './locales/it.json'

// Custom language detector that uses IndexedDB
const indexedDBDetector = {
  type: 'languageDetector' as const,
  
  init() {
    // No initialization needed
  },

  detect(callback?: (lng: string) => void) {
    (async () => {
      try {
        // Try to get language from IndexedDB first
        const savedLanguage = await storage.getPreference('i18n-language')
        if (savedLanguage) {
          if (callback) callback(savedLanguage)
          return savedLanguage
        }
        
        // Fallback to browser language detection
        const browserLang = navigator.language || (navigator as any).languages?.[0] || 'it'
        
        // For this app, we only support Italian for now
        const language = 'it'
        if (callback) callback(language)
        return language
      } catch (error) {
        console.error('Failed to detect language:', error)
        const language = 'it'
        if (callback) callback(language)
        return language
      }
    })()
  },

  cacheUserLanguage(lng: string) {
    // Save language preference to IndexedDB
    storage.savePreference('i18n-language', lng).catch(error => {
      console.error('Failed to cache language:', error)
    })
  }
}

i18n
  .use(indexedDBDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it',
    lng: 'it', // Default to Italian
    debug: false,
    
    interpolation: {
      escapeValue: false
    },
    
    resources: {
      it: {
        translation: itTranslations
      }
    }
  })

export default i18n